import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { emit, trackAffinity } from "@/lib/events";

const WishlistContext = createContext(null);
const KEY = "siyaara_wishlist";

export function WishlistProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const isWishlisted = (id) => items.some((i) => i.id === id);

  const toggle = (product) => {
    if (isWishlisted(product.id)) {
      setItems((prev) => prev.filter((i) => i.id !== product.id));
      toast.info("Removed from wishlist");
      trackAffinity(product, "wishlist_remove");
    } else {
      setItems((prev) => [
        ...prev,
        {
          id: product.id, slug: product.slug, title: product.title,
          image: (product.images || [])[0] || "",
          price_min: product.price_min ?? product.variants?.[0]?.pricing?.final ?? 0,
          metal: product.metal, purity: product.purity,
        },
      ]);
      toast.success("Saved to wishlist");
      trackAffinity(product, "wishlist");
      emit("add_to_wishlist", {
        items: [{ item_id: product.id, item_name: product.title, price: product.price_min ?? product.variants?.[0]?.pricing?.final ?? 0, quantity: 1 }],
      });
    }
  };

  return (
    <WishlistContext.Provider value={{ items, isWishlisted, toggle }}>
      {children}
    </WishlistContext.Provider>
  );
}

export const useWishlist = () => useContext(WishlistContext);
